export const voicePreviewTemplates: Record<string, Record<string, string>> = {
  '*': {
    notSpecified: 'Hi, my name is {{ name }}. I am an English voice from the {{ country }}.'
  },
  en: {
    notSpecified: 'Hi, my name is {{ name }}. I am an English voice from the {{ country }}.'
  },
  'en-US': {
    notSpecified: 'Hi, my name is {{ name }}. I am an American English voice from the United States.'
  },
  'en-GB': {
    notSpecified: 'Hi, my name is {{ name }}. I am a British English voice from the United Kingdom.'
  },
  'en-AU': {
    notSpecified: 'Hi, my name is {{ name }}. I am an Australian English voice from Australia.'
  },
  'en-IN': {
    notSpecified: 'Hi, my name is {{ name }}. I am an Indian English voice from India.'
  },
  'en-NG': {
    notSpecified: 'Hi, my name is {{ name }}. I am a Nigerian English voice from Nigeria.'
  },
  'en-ZA': {
    notSpecified: 'Hi, my name is {{ name }}. I am a South African English voice from South Africa.'
  },
  'en-IE': {
    notSpecified: 'Hi, my name is {{ name }}. I am an Irish English voice from Ireland.'
  },
  de: {
    notSpecified: 'Hallo, mein Name ist {{ name }}. Ich bin eine deutschsprachige Stimme.'
  },
  'de-DE': {
    notSpecified: 'Hallo, mein Name ist {{ name }}. Ich bin eine deutsche Stimme aus Deutschland.'
  },
  'de-CH': {
    notSpecified: 'Grüezi, ich heiße {{ name }}. Ich bin eine deutschsprachige Stimme aus der Schweiz.'
  },
  pt: {
    notSpecified: 'Olá, meu nome é {{ name }}. Sou uma voz em português.'
  },
  'pt-BR': {
    notSpecified: 'Olá, meu nome é {{ name }}. Sou uma voz em português do Brasil.'
  },
  'pt-PT': {
    notSpecified: 'Olá, o meu nome é {{ name }}. Sou uma voz portuguesa de Portugal.'
  },
  es: {
    notSpecified: 'Hola, mi nombre es {{ name }}. Soy una voz en español.'
  },
  'es-ES': {
    notSpecified: 'Hola, mi nombre es {{ name }}. Soy una voz española de España.'
  },
  'es-MX': {
    notSpecified: 'Hola, mi nombre es {{ name }}. Soy una voz mexicana de México.'
  },
  'es-US': {
    notSpecified: 'Hola, mi nombre es {{ name }}. Soy una voz en español de Estados Unidos.'
  },
  it: {
    notSpecified: 'Ciao, mi chiamo {{ name }}. Sono una voce italiana.'
  },
  'it-IT': {
    notSpecified: "Ciao, mi chiamo {{ name }}. Sono una voce italiana dall'Italia."
  },
  fr: {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis une voix française."
  },
  'fr-FR': {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis une voix française de France."
  },
  'fr-BE': {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis une voix française de Belgique."
  },
  'fr-CA': {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis une voix française du Canada."
  },
  'fr-CH': {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis une voix française de Suisse."
  },
  ja: {
    notSpecified: 'こんにちは、私の名前は{{ name }}です。私は日本語の声です。'
  },
  'ja-JP': {
    notSpecified: 'こんにちは、私の名前は{{ name }}です。私は日本の日本語の声です。'
  },
  zh: {
    notSpecified: '您好，我是{{ name }}。我是中文声音。'
  },
  'zh-CN': {
    notSpecified: '您好，我是{{ name }}。我是中国的中文声音。'
  },
  'zh-HK': {
    notSpecified: '您好，我是{{ name }}。我是香港的中文声音。'
  },
  'zh-TW': {
    notSpecified: '您好，我是{{ name }}。我是臺灣的中文聲音。'
  },
  da: {
    notSpecified: 'Hej, jeg hedder {{ name }}. Jeg er en dansk stemme.'
  },
  'da-DK': {
    notSpecified: 'Hej, jeg hedder {{ name }}. Jeg er en dansk stemme fra Danmark.'
  },
  fi: {
    notSpecified: 'Hei, nimeni on {{ name }}. Olen ääni Suomesta.'
  },
  'fi-FI': {
    notSpecified: 'Hei, nimeni on {{ name }}. Olen suomalainen ääni Suomesta.'
  },
  id: {
    notSpecified: 'Halo, nama saya {{ name }}. Saya suara berbahasa Indonesia dari {{ country }}.'
  },
  'id-ID': {
    notSpecified: 'Halo, nama saya {{ name }}. Saya suara bahasa Indonesia dari Indonesia.'
  },
  ms: {
    notSpecified: 'Hai, nama saya {{ name }}. Saya suara berbahasa Melayu dari {{ country }}.'
  },
  'ms-MY': {
    notSpecified: 'Hai, nama saya {{ name }}. Saya suara bahasa Melayu dari Malaysia.'
  },
  ne: {
    notSpecified: 'नमस्कार, मेरो नाम {{ name }} हो। म {{ country }} बाट {{ language }} आवाज हुँ।'
  },
  'ne-NP': {
    notSpecified: 'नमस्कार, मेरो नाम {{ name }} हो। म नेपालबाट नेपाली आवाज हुँ।'
  },
  ta: {
    notSpecified: 'வணக்கம், என் பெயர் {{ name }}. நான் {{ country }}-இல் இருந்து தமிழ் குரல்.'
  },
  'ta-IN': {
    notSpecified: 'வணக்கம், என் பெயர் {{ name }}. நான் இந்திய தமிழின் குரல்.'
  },
  'ta-LK': {
    notSpecified: 'வணக்கம், என் பெயர் {{ name }}. நான் இலங்கைத் தமிழின் குரல்.'
  },
  'ta-MY': {
    notSpecified: 'வணக்கம், என் பெயர் {{ name }}. நான் மலேசிய தமிழ் குரல்.'
  },
  'ta-SG': {
    notSpecified: 'வணக்கம், என் பெயர் {{ name }}. நான் சிங்கப்பூர் தமிழின் குரல்.'
  },
  te: {
    notSpecified: 'హలో, నా పేరు {{ name }}. నేను {{ country }} నుంచి తెలుగు స్వరం.'
  },
  'te-IN': {
    notSpecified: 'హలో, నా పేరు {{ name }}. నేను భారతదేశం నుండి తెలుగు స్వరం.'
  },
  th: {
    notSpecified: 'สวัสดี, ฉันชื่อ {{ name }}. ฉันเป็นเสียงภาษาไทยจาก {{ country }}.'
  },
  'th-TH': {
    notSpecified: 'สวัสดี, ฉันชื่อ {{ name }}. ฉันเป็นเสียงภาษาไทยจากประเทศไทย.'
  },
  ur: {
    notSpecified: 'سلام، میرا نام {{ name }} ہے۔ میں {{ country }} سے {{ language }} کی آواز ہوں۔'
  },
  'ur-IN': {
    notSpecified: 'سلام، میرا نام {{ name }} ہے۔ میں ہندوستان کی اردو آواز ہوں۔'
  },
  'ur-PK': {
    notSpecified: 'سلام، میرا نام {{ name }} ہے۔ میں پاکستان کی اردو آواز ہوں۔'
  },
  yue: {
    notSpecified: '你好，我叫{{ name }}。我係廣東話聲音。'
  },
  'yue-CN': {
    notSpecified: '你好，我叫{{ name }}。我係中國廣東話聲音。'
  },
  cmn: {
    notSpecified: '您好，我是{{ name }}。我是普通话声音。'
  },
  'cmn-CN': {
    notSpecified: '您好，我是{{ name }}。我是中国普通话声音。'
  },
  lt: {
    notSpecified: 'Labas, mano vardas yra {{ name }}. Aš esu {{ country }} kalbos balsas.'
  },
  'lt-LT': {
    notSpecified: 'Labas, mano vardas yra {{ name }}. Aš esu Lietuvos kalbos balsas.'
  },
  lv: {
    notSpecified: 'Sveiki, mans vārds ir {{ name }}. Es esmu balss no {{ country }}.'
  },
  'lv-LV': {
    notSpecified: 'Sveiki, mans vārds ir {{ name }}. Es esmu balss no Latvijas.'
  },
  sk: {
    notSpecified: 'Ahoj, moje meno je {{ name }}. Som hlas zo Slovenska.'
  },
  'sk-SK': {
    notSpecified: 'Ahoj, moje meno je {{ name }}. Som slovenský hlas zo Slovenska.'
  },
  sl: {
    notSpecified: 'Pozdravljeni, moje ime je {{ name }}. Sem glas iz Slovenije.'
  },
  'sl-SI': {
    notSpecified: 'Pozdravljeni, moje ime je {{ name }}. Sem slovenski glas iz Slovenije.'
  },
  ro: {
    notSpecified: 'Salut, numele meu este {{ name }}. Sunt o voce din România.'
  },
  'ro-RO': {
    notSpecified: 'Salut, numele meu este {{ name }}. Sunt o voce din România.'
  },
  ru: {
    notSpecified: 'Здравствуйте, меня зовут {{ name }}. Я голос из России.'
  },
  'ru-RU': {
    notSpecified: 'Здравствуйте, меня зовут {{ name }}. Я русский голос из России.'
  },
  uk: {
    notSpecified: 'Привіт, мене звати {{ name }}. Я голос з України.'
  },
  'uk-UA': {
    notSpecified: 'Привіт, мене звати {{ name }}. Я український голос з України.'
  },
  sv: {
    notSpecified: 'Hej, jag heter {{ name }}. Jag är en svensk röst.'
  },
  'sv-SE': {
    notSpecified: 'Hej, jag heter {{ name }}. Jag är en svensk röst från Sverige.'
  },
  af: {
    notSpecified: "Hallo, my naam is {{ name }}. Ek is 'n Afrikaanse stem van {{ country }}."
  },
  'af-ZA': {
    notSpecified: "Hallo, my naam is {{ name }}. Ek is 'n Afrikaanse stem van Suid-Afrika."
  },
  ar: {
    notSpecified: 'مرحبًا، اسمي {{ name }}. أنا صوت باللغة العربية.'
  },
  'ar-AE': {
    notSpecified: 'مرحبًا، اسمي {{ name }}. أنا صوت من الإمارات العربية المتحدة.'
  },
  'ar-IQ': {
    notSpecified: 'مرحبًا، اسمي {{ name }}. أنا صوت من العراق.'
  },
  bg: {
    notSpecified: 'Здравейте, казвам се {{ name }}. Аз съм глас от България.'
  },
  'bg-BG': {
    notSpecified: 'Здравейте, казвам се {{ name }}. Аз съм български глас от България.'
  },
  bn: {
    notSpecified: 'হ্যালো, আমার নাম {{ name }}। আমি বাংলা ভাষার কণ্ঠ।'
  },
  'bn-IN': {
    notSpecified: 'হ্যালো, আমার নাম {{ name }}। আমি ভারতের বাংলা ভাষার কণ্ঠ।'
  },
  ca: {
    notSpecified: 'Hola, em dic {{ name }}. Sóc una veu en català.'
  },
  'ca-ES': {
    notSpecified: "Hola, em dic {{ name }}. Sóc una veu catalana d'Espanya."
  },
  cs: {
    notSpecified: 'Ahoj, jmenuji se {{ name }}. Jsem hlas z České republiky.'
  },
  'cs-CZ': {
    notSpecified: 'Ahoj, jmenuji se {{ name }}. Jsem český hlas z České republiky.'
  },
  el: {
    notSpecified: 'Γεια σας, με λένε {{ name }}. Είμαι φωνή από την Ελλάδα.'
  },
  'el-GR': {
    notSpecified: 'Γεια σας, με λένε {{ name }}. Είμαι ελληνική φωνή από την Ελλάδα.'
  },
  et: {
    notSpecified: 'Tere, minu nimi on {{ name }}. Olen hääl Eestist.'
  },
  'et-EE': {
    notSpecified: 'Tere, minu nimi on {{ name }}. Olen eestikeelne hääl Eestist.'
  },
  fa: {
    notSpecified: 'سلام، نام من {{ name }} است. من یک صدای فارسی هستم.'
  },
  'fa-IR': {
    notSpecified: 'سلام، نام من {{ name }} است. من یک صدای فارسی از ایران هستم.'
  },
  fil: {
    notSpecified: 'Kamusta, ang pangalan ko ay {{ name }}. Ako ay isang boses mula sa Pilipinas.'
  },
  'fil-PH': {
    notSpecified: 'Kamusta, ang pangalan ko ay {{ name }}. Ako ay isang boses mula sa Pilipinas.'
  },
  ga: {
    notSpecified: 'Dia duit, is mise {{ name }}. Is mé guth ó Éirinn.'
  },
  'ga-IE': {
    notSpecified: 'Dia duit, is mise {{ name }}. Is mé guth Éireannach ó Éirinn.'
  },
  he: {
    notSpecified: 'שלום, קוראים לי {{ name }}. אני קול בעברית.'
  },
  'he-IL': {
    notSpecified: 'שלום, קוראים לי {{ name }}. אני קול מעיר ישראל.'
  },
  hi: {
    notSpecified: 'नमस्ते, मेरा नाम {{ name }} है। मैं हिंदी आवाज़ हूँ।'
  },
  'hi-IN': {
    notSpecified: 'नमस्ते, मेरा नाम {{ name }} है। मैं भारत की हिंदी आवाज़ हूँ।'
  },
  hr: {
    notSpecified: 'Bok, ja sam {{ name }}. Ja sam glas iz Hrvatske.'
  },
  'hr-HR': {
    notSpecified: 'Bok, ja sam {{ name }}. Ja sam glas iz Hrvatske.'
  },
  hu: {
    notSpecified: 'Szia, a nevem {{ name }}. Egy magyar hang vagyok.'
  },
  'hu-HU': {
    notSpecified: 'Szia, a nevem {{ name }}. Egy magyar hang vagyok Magyarországról.'
  },
  is: {
    notSpecified: 'Halló, ég heiti {{ name }}. Ég er íslensk rödd.'
  },
  'is-IS': {
    notSpecified: 'Halló, ég heiti {{ name }}. Ég er íslensk rödd frá Íslandi.'
  },
  ka: {
    notSpecified: 'გამარჯობა, მე მქვია {{ name }}. მე ვარ ხმა საქართველოდან.'
  },
  'ka-GE': {
    notSpecified: 'გამარჯობა, მე მქვია {{ name }}. მე ვარ ქართული ხმა საქართველოდან.'
  },
  kk: {
    notSpecified: 'Сәлеметсіз бе, менің атым {{ name }}. Мен қазақ тілінің даусымын.'
  },
  'kk-KZ': {
    notSpecified: 'Сәлеметсіз бе, менің атым {{ name }}. Мен қазақ тілінің даусымын Қазақстаннан.'
  },
  ko: {
    notSpecified: '안녕하세요, 제 이름은 {{ name }}입니다. 저는 한국어 목소리입니다.'
  },
  'ko-KR': {
    notSpecified: '안녕하세요, 제 이름은 {{ name }}입니다. 저는 대한민국의 한국어 목소리입니다.'
  },
  nl: {
    notSpecified: 'Hallo, mijn naam is {{ name }}. Ik ben een Nederlandse stem.'
  },
  'nl-BE': {
    notSpecified: 'Hallo, mijn naam is {{ name }}. Ik ben een Nederlandse stem uit België.'
  },
  'nl-NL': {
    notSpecified: 'Hallo, mijn naam is {{ name }}. Ik ben een Nederlandse stem uit Nederland.'
  },
  nb: {
    notSpecified: 'Hei, jeg heter {{ name }}. Jeg er en norsk stemme.'
  },
  'nb-NO': {
    notSpecified: 'Hei, jeg heter {{ name }}. Jeg er en norsk stemme fra Norge.'
  },
  pl: {
    notSpecified: 'Cześć, mam na imię {{ name }}. Jestem głosem polskim.'
  },
  'pl-PL': {
    notSpecified: 'Cześć, mam na imię {{ name }}. Jestem polskim głosem z Polski.'
  },
  si: {
    notSpecified: 'හෙලෝ, මගේ නම {{ name }}. මම {{ country }} වෙතින් සිංහල හඬක්.'
  },
  'si-LK': {
    notSpecified: 'හෙලෝ, මගේ නම {{ name }}. මම ශ්‍රී ලංකාවේ සිංහල හඬක්.'
  },
  sw: {
    notSpecified: 'Habari, jina langu ni {{ name }}. Mimi ni sauti ya Kiswahili kutoka {{ country }}.'
  },
  'sw-TZ': {
    notSpecified: 'Habari, jina langu ni {{ name }}. Mimi ni sauti ya Kiswahili kutoka Tanzania.'
  },
  tr: {
    notSpecified: 'Merhaba, benim adım {{ name }}. Ben bir Türkçe sesim.'
  },
  'tr-TR': {
    notSpecified: "Merhaba, benim adım {{ name }}. Ben Türkiye'den bir Türkçe sesim."
  },
  vi: {
    notSpecified: 'Xin chào, tôi tên là {{ name }}. Tôi là giọng nói tiếng Việt.'
  },
  'vi-VN': {
    notSpecified: 'Xin chào, tôi tên là {{ name }}. Tôi là giọng nói tiếng Việt từ Việt Nam.'
  }
};
